// extracted by mini-css-extract-plugin
export default {"ingredientsSection":"aI-z","listContainer":"bI-z","ingredients":"cI-z","description":"dI-z"};